import { makeAutoObservable } from 'mobx'
import type { IChatbotSettings } from '../type'

export class ChatbotTrigger {
  allowReEntering = false

  constructor() {
    makeAutoObservable(this)
  }

  setAllowReEntering = (value: boolean) => {
    this.allowReEntering = value
  }

  syncOrigin(settings?: IChatbotSettings | null) {
    this.allowReEntering = settings?.allow_re_entering?.value ?? false
  }

  toJSON(): Pick<IChatbotSettings, 'allow_re_entering'> {
    return {
      allow_re_entering: { value: this.allowReEntering },
    }
  }
}
